import moment from 'moment';
import { reduxRoadToCurrentSettingsTypes } from 'src/types';
import {
  ROAD_TO_CURRENT_SETTINGS_SET,
  ROAD_TO_CURRENT_SETTINGS_ADDED,
  ROAD_TO_CURRENT_SETTINGS_UPDATED,
  ROAD_TO_CURRENT_SETTINGS_DELETED,
} from '../redux-types/contents.types';

export const roadToCurrentSettingsDefaultState: reduxRoadToCurrentSettingsTypes.StateType = {
  roadToCurrentSettingsList: [],
};

export const roadToCurrentSettingsReducer = (
  state = roadToCurrentSettingsDefaultState,
  action: reduxRoadToCurrentSettingsTypes.ActionType,
): reduxRoadToCurrentSettingsTypes.StateType => {
  switch (action.type) {
    case ROAD_TO_CURRENT_SETTINGS_SET:
      return {
        ...state,
        roadToCurrentSettingsList: action.payload,
      };
    case ROAD_TO_CURRENT_SETTINGS_ADDED:
      const newRoadToCurrentSettingsList = [...state.roadToCurrentSettingsList, action.payload];
      newRoadToCurrentSettingsList.sort((a, b) => moment(b.incidentDate).diff(moment(a.incidentDate)));

      return {
        ...state,
        roadToCurrentSettingsList: newRoadToCurrentSettingsList,
      };
    case ROAD_TO_CURRENT_SETTINGS_UPDATED:
      const updatedIndex = state.roadToCurrentSettingsList.findIndex((obj) => obj.id === action.payload.id);

      return {
        ...state,
        roadToCurrentSettingsList: [
          ...state.roadToCurrentSettingsList.slice(0, updatedIndex),
          action.payload,
          ...state.roadToCurrentSettingsList.slice(updatedIndex + 1),
        ],
      };
    case ROAD_TO_CURRENT_SETTINGS_DELETED:
      return {
        ...state,
        roadToCurrentSettingsList: state.roadToCurrentSettingsList.filter((obj) => obj.id !== action.payload),
      };

    default:
      return state;
  }
};
